import {
  createContext,
  type PropsWithChildren,
  useContext,
  useState,
} from 'react';
import Confetti from 'react-confetti';
import { useWindowSize } from 'usehooks-ts';

export type ConfettiTriggerParams = {};
export type ConfettiTrigger = (params: ConfettiTriggerParams) => void;

const ConfettiContext = createContext<ConfettiTrigger>(() => ({}));

export function ConfettiProvider({ children }: PropsWithChildren<{}>) {
  const { width, height } = useWindowSize();
  const [params, setParams] = useState<ConfettiTriggerParams | undefined>(
    undefined,
  );

  function addConfetti(params: ConfettiTriggerParams) {
    setParams(params);
  }
  function removeConfetti() {
    setParams(undefined);
  }

  return (
    <>
      <ConfettiContext.Provider value={addConfetti}>
        {children}
      </ConfettiContext.Provider>
      {params ? (
        <Confetti
          width={width}
          height={height}
          recycle={false}
          numberOfPieces={200}
          onConfettiComplete={removeConfetti}
        />
      ) : null}
    </>
  );
}

export function useConfetti(): ConfettiTrigger {
  return useContext(ConfettiContext);
}
